import { unwrap } from '@mrigl/api-client';
import { api } from '../../api.js';

/**
 * The plan a visitor clicked on the landing page (ADR 0027), kept for this browser tab through
 * sign-up and store creation, then chosen in the new store's wizard.
 */
const KEY = 'mrigl.signupPlan';
const CODE = /^[a-z0-9-]{2,40}$/;

export function rememberSignupPlan(code: string | null): void {
  if (code === null || !CODE.test(code)) return;
  try {
    globalThis.sessionStorage.setItem(KEY, code);
  } catch {
    // Without storage the wizard simply asks for the plan.
  }
}

function takeSignupPlan(): string | null {
  try {
    const code = globalThis.sessionStorage.getItem(KEY);
    globalThis.sessionStorage.removeItem(KEY);
    return code !== null && CODE.test(code) ? code : null;
  } catch {
    return null;
  }
}

/**
 * Chooses the remembered plan for the store when it is still offered and the store may choose.
 * Returns whether a plan was chosen; otherwise the plan step asks as usual.
 */
export async function applySignupPlan(storeId: string): Promise<boolean> {
  const code = takeSignupPlan();
  if (code === null) return false;
  try {
    const offered = await unwrap(
      api.GET('/admin-api/v1/stores/{storeId}/billing/plans', { params: { path: { storeId } } }),
    );
    const plan = offered.items.find((item) => item.code === code);
    if (plan === undefined || !offered.canChoose) return false;
    if (offered.currentPlanId === plan.planId) return true;
    await unwrap(
      api.PUT('/admin-api/v1/stores/{storeId}/billing/plan', {
        params: { path: { storeId } },
        body: { planId: plan.planId },
      }),
    );
    return true;
  } catch {
    return false;
  }
}
